const listDefaultPageActions = [
    {
        title: 'Add New',
        to: '/bolt-on',
    },
];

export const listPageActions = (displayType, anyDisabled) => {
    switch (displayType) {
        case 'disabled':
            return [
                {
                    title: 'Show Active',
                    to: '/bolt-ons',
                },
                ...listDefaultPageActions,
            ];
        case 'active':
        default:
            if (anyDisabled) {
                return [
                    {
                        title: 'Show Disabled',
                        to: '/bolt-ons/disabled',
                    },
                    ...listDefaultPageActions,
                ];
            } else {
                return listDefaultPageActions;
            }
    }
};

export const editPageActions = [
    {
        title: 'Back',
        to: '/bolt-ons',
    },
];
